<template>
  <div
    :class="{ 'has-logo': showLogo, 'is-collapse': isCollapse }"
    class="side-bar"
  >
    <svg-icon icon-class="customer_sidebar_bg" class-name="sidebarBg" />
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        text-color="white"
        :unique-opened="false"
        active-text-color="white"
        :collapse-transition="true"
        mode="vertical"
        class="sidebar-menu"
      >
        <sidebar-item
          v-for="route in user.routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";

export default {
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters(["user", "sidebar"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return true;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-scrollbar{ 
  flex: 1;
}
::v-deep .el-scrollbar__view{ 
  height:100%;
}
.side-bar {
  background-color: $sideBarBgColor;

  .sidebarBg {
    position: absolute;
    width: 900px;
    height: 500px;
    z-index: -1;
    opacity: 0.6;
  }

  .el-menu {
    background-color: #0000;
    overflow: auto;

    // a {
    //   display: inline-block;
    //   width: 100%;
    //   overflow: hidden;
    //   background-color: #0000;

    //   &:hover {
    //     background-color: $menuHoverColor;
    //   }
    // }
  }

  // // reset element-ui css
  // .horizontal-collapse-transition {
  //   transition: 0s width ease-in-out, 0s padding-left ease-in-out,
  //     0s padding-right ease-in-out;
  // }
  // .scrollbar-wrapper {
  //   overflow-x: hidden !important;
  // }
  // .el-scrollbar__bar.is-vertical {
  //   right: 0px;
  // }
  // .el-scrollbar {
  //   flex: 1;
  // }
  // .is-horizontal {
  //   display: none;
  // }

  // .svg-icon {
  //   margin-right: 16px;
  // }
  // .sub-el-icon {
  //   margin-right: 12px;
  //   margin-left: -2px;
  // }
  // .el-menu {
  //   border: none;
  //   height: 100%;
  //   width: 100% !important;
  //   background-color: #0000;
  // }

  // // menu hover
  // .submenu-title-noDropdown,
  // .el-submenu__title {
  //   color: white;
  //   font-size: 15px;
  //   font-weight: bold;
  //   .el-icon-arrow-down {
  //     margin-top: -4px;
  //   }
  //   &:hover {
  //     background-color: $menuHoverColor !important;
  //   }
  // }
  // .submenu-title-noDropdown {
  //   background-color: #0000;
  // }
  // .nest-menu .el-submenu > .el-submenu__title,
  // .el-submenu .el-menu-item {
  //   min-width: $sideBarWidth !important;
  //   background-color: #0000 !important;
  //   color: white;
  //   font-size: 15px;
  //   text-align: center;
  //   &:hover {
  //     background-color: $menuHoverColor !important;
  //   }
  //   & .is-active {
  //     background-color: $menuActiveColor !important;
  //   }
  // }
  // & .submenu-title-noDropdown {
  //   &.is-active {
  //     background-color: $menuActiveColor !important;
  //   }
  // }

  // .el-menu--collapse .el-menu .el-submenu {
  //   min-width: $sideBarWidth !important;
  // }
}

// .is-collapse {
//   .submenu-title-noDropdown {
//     padding: 0 !important;
//     position: relative;
//     .el-tooltip {
//       padding: 0 !important;
//       .svg-icon {
//         margin-left: 20px;
//       }
//       .sub-el-icon {
//         margin-left: 19px;
//       }
//     }
//   }
//   .el-submenu {
//     overflow: hidden;
//     & > .el-submenu__title {
//       padding: 0 !important;
//       .svg-icon {
//         margin-left: 20px;
//       }
//       .sub-el-icon {
//         margin-left: 19px;
//       }
//       .el-submenu__icon-arrow {
//         display: none;
//       }
//     }
//     &.is-active {
//       background-color: $menuActiveColor;
//     }
//   }
//   .el-menu--collapse {
//     .el-submenu {
//       & > .el-submenu__title {
//         & > span {
//           height: 0;
//           width: 0;
//           overflow: hidden;
//           visibility: hidden;
//           display: inline-block;
//         }
//       }
//     }
//   }
// }

// .el-submenu__icon-arrow {
//   color: white;
// }
</style>
